export const FETCH_TOURNAMENT_INJURIES_REQUEST = 'tournament/injury/fetch/request';
export const FETCH_TOURNAMENT_INJURIES_SUCCESS = 'tournament/injury/fetch/success';
export const FETCH_TOURNAMENT_INJURIES_FAIL = 'tournament/injury/fetch/fail';
